/**
 * Central, host-independent form configuration.
 *
 * Every form on the site submits to a single configurable endpoint. Nothing is
 * hardcoded to any platform, so the built site works on any Apache / Nginx /
 * IIS / Node / PHP host.
 *
 * Configuration is read from Vite environment variables (a `.env` file or your
 * host's environment). All of them are PUBLIC values — no secrets belong here.
 *
 *   VITE_PUBLIC_FORM_ENDPOINT            -> where forms POST to (default "/contact.php")
 *   VITE_PUBLIC_TURNSTILE_SITE_KEY       -> optional Cloudflare Turnstile site key
 *   VITE_PUBLIC_RECAPTCHA_SITE_KEY       -> optional Google reCAPTCHA v3 site key
 *
 * The matching SECRET keys live on the server only (see src/backend/).
 */

const rawEndpoint = import.meta.env.VITE_PUBLIC_FORM_ENDPOINT as string | undefined;

/** Endpoint every form submits to. Override with VITE_PUBLIC_FORM_ENDPOINT. */
export const FORM_ENDPOINT =
  typeof rawEndpoint === "string" && rawEndpoint.trim().length > 0
    ? rawEndpoint.trim()
    : "/contact.php";

const rawTurnstile = import.meta.env.VITE_PUBLIC_TURNSTILE_SITE_KEY as string | undefined;
const rawRecaptcha = import.meta.env.VITE_PUBLIC_RECAPTCHA_SITE_KEY as string | undefined;

/** Optional Cloudflare Turnstile public site key (empty = disabled). */
export const TURNSTILE_SITE_KEY =
  typeof rawTurnstile === "string" ? rawTurnstile.trim() : "";

/** Optional Google reCAPTCHA v3 public site key (empty = disabled). */
export const RECAPTCHA_SITE_KEY =
  typeof rawRecaptcha === "string" ? rawRecaptcha.trim() : "";

/** True when any optional anti-bot protection is configured. */
export const HAS_ANTI_BOT = TURNSTILE_SITE_KEY.length > 0 || RECAPTCHA_SITE_KEY.length > 0;

/** Public contact fallback used in user-facing error messages. */
export const FALLBACK_CONTACT = "please call us at +91-99863 03349";